import { render, staticRenderFns } from "./ClockDate.vue?vue&type=template&id=c38e2040&scoped=true&"
import script from "./ClockDate.vue?vue&type=script&lang=js&"
export * from "./ClockDate.vue?vue&type=script&lang=js&"
import style0 from "./ClockDate.vue?vue&type=style&index=0&id=c38e2040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38e2040",
  null
  
)

export default component.exports